<template>
  <v-app>
   <v-content>
     <LeftNav></LeftNav>
     <TopNav></TopNav>
     <router-view></router-view>
     <RightNav></RightNav>
   </v-content>
 </v-app>
</template>
<script>
export default {
  name: 'HomeWrap',
  data: () => ({
    routeWithPermissions: [],
  }),
  props: {
    source: String,
  },

  watch: {
    // watch route with permission , if no permission push to application 
     '$route': {
        handler: function(val) {
          const self = this;
          let currentRouteName = val.name;
          this.$router.options.routes.forEach((route) => {
            self.routeWithPermissions.push({
              name:  route.name,
              checkAccess: route.checkAccess ? route.checkAccess.split('|') : '',
            });
            if ('children' in route) {
              route.children.forEach((childRoute) => {
                self.routeWithPermissions.push({
                  name:  childRoute.name,
                  checkAccess: childRoute.checkAccess ? childRoute.checkAccess.split('|') : '',
                });
              })
            }
          });
          let currentRoute = this.routeWithPermissions.filter( item => item.name == currentRouteName);
          let redirect = true;
          if(currentRoute[0].checkAccess == '') {
            let redirect = false;
          } else {
            currentRoute[0].checkAccess.forEach(permission => {
              if(this.$store.getters[permission]){
                redirect = false;
              }
            })
            if(redirect) {
              this.$router.push({ name: 'Applications' });
            }
          }
        },
        deep: true,
        immediate: true
      }
  },
};
</script>
